import Features from "../Components/AiComponents/modules/pricing/Features";
import Frequently from "../Components/AiComponents/modules/pricing/Frequently";
import MakeShip from "../Components/AiComponents/modules/pricing/MakeShip";
import Plans from "../Components/AiComponents/modules/pricing/Plans";
import LandingLayout from "../layouts/LandingLayout";

function Pricing() {
  return (
    <>
      <LandingLayout className="bg-black">
        <div className="w-full flex flex-col justify-between mt-32 sm:w-[95%] relative border border-subColor4 md:w-[80%] xl:w-[75%] txl:w-[65%]">
          <Plans />
          <Features />
          <Frequently />
        </div>
        <MakeShip />
      </LandingLayout>
    </>
  );
}

export default Pricing;
